<!-- Left -->
<frontend-conversation-list [list]="list"></frontend-conversation-list>

<!-- Right -->
<div style="display: flex; flex-grow: 1; flex-direction: column">
  <ng-content></ng-content>
</div>
